import { createAsyncThunk } from "@reduxjs/toolkit";

import { getAffiliateProfile } from "../../helpers/backend_helper";

export const fetchAffiliateProfileThunk = createAsyncThunk<
  any,
  number,
  { rejectValue: Error }
>(
  "affiliateProfile/fetchAffiliateProfile",
  async (affiliateId, { rejectWithValue }) => {
    try {
      const response = await getAffiliateProfile(affiliateId);

      return response;
    } catch (error) {
      return rejectWithValue(error as Error);
    }
  }
);
